module.exports = "<div class=\"row\">\n    <div class=\"col-sm-4\" >\n      <div class=\"hero-unit center\">\n          <h1>Page Not Found <small><font face=\"Tahoma\" color=\"red\">Error 404</font></small></h1>\n          <br />\n        </div>\n        <br />\n     \n    </div>\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/errors/error404/error404.component.html
// module id = ./src/app/shared/errors/error404/error404.component.html
// module chunks = main